import { useEffect } from "react";
import { ScriptProps } from "./ScriptProps";

const Script: React.FC<ScriptProps> = ({ src, defer, handlers }) => {
  useEffect(() => {
    // Load the HubSpot embed script
    const script = document.createElement("script");
    script.src = src;
    script.defer = defer;
    document.body.appendChild(script);

    if (handlers) {
      handlers.forEach((handler) => {
        script.addEventListener(handler.event, handler.handler);
      });
    }

    return () => {
      // Cleanup
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [src, defer, handlers]);

  return <></>;
};

export default Script;
